<template>
	<v-container class="mt-12 pt-8" style="background:#fafafa;">
		<v-row style="background:#fafafa;">
			<v-col cols="12" class="pa-0">
				<v-row class="py-1 px-5">
					<v-col cols="12" md="12" LeadsPannel>
						<v-row>
							<v-col cols="12" LEADSPANEL>
								<v-card :loading="loading">
									<v-card-text class="py-0">
										<v-row class="align-center">
											<v-col cols="12">
												<v-row class="align-center">
													<v-col cols="2" class="text-center" TITLE>
														<v-icon size="40" color="secondary">description</v-icon>
													</v-col>
													<v-col cols="10" TITLE>
														<div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">
														{{ i18n["service_pages"] }}
														</div>
														<div :class="`${arabic ? 'arFont' : 'enFont'} grey--text`">{{ i18n['start_a_new_service_page'] }}</div>
													</v-col>
												</v-row>
											</v-col>
											<v-col cols="12" class=" py-0">
												<Form @onSubmit="onSubmit" :resource.sync="resource" />
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import Form from './Form.vue';

export default {
	components: {
		Form
	},
	data() {
		return {
			loading: false,
			resource: {
				title: "",
				body: "",
				image: "",
				contact_url: ""
			}
		};
	},
	methods: {
		getUpload(image) {
			this.resource.image = image.value
		},
		async onSubmit() {
			this.loading = true
			await this.$store.dispatch('postResource', { resource: '/service-pages', value: this.resource })
			this.loading = false
			this.$router.push('/service-pages')
		}
	},
	computed: {
		language() {
			return this.$store.state.language;
		},
		i18n() {
			return this.$store.state.i18n[this.$store.state.language];
		},
		arabic() {
			if (this.$store.state.language == "ar")
				return true;
		},
	},
}
</script>